import { supabase } from './supabase';

export async function exportUserData(householdId) {
  const [
    { data: household },
    { data: members },
    { data: recipes },
    { data: swipes },
    { data: plans },
    { data: feedback },
  ] = await Promise.all([
    supabase.from('households').select('*').eq('id', householdId).single(),
    supabase.from('family_members').select('*').eq('household_id', householdId),
    supabase.from('recipes').select('*').eq('household_id', householdId),
    supabase.from('preference_swipes').select('*').in(
      'member_id',
      (await supabase.from('family_members').select('id').eq('household_id', householdId))
        .data?.map((m) => m.id) || []
    ),
    // RPC instead of a direct select: the meal_plans SELECT policy hides
    // history older than 28 days from Free households, but exports must
    // always contain ALL user data.
    supabase.rpc('export_my_meal_plans'),
    supabase.from('meal_feedback').select('*').in(
      'member_id',
      (await supabase.from('family_members').select('id').eq('household_id', householdId))
        .data?.map((m) => m.id) || []
    ),
  ]);

  // Also fetch global seed recipes for context
  const { data: globalRecipes } = await supabase
    .from('recipes')
    .select('*')
    .is('household_id', null);

  const exportData = {
    exported_at: new Date().toISOString(),
    version: '1.0',
    household: household || null,
    family_members: members || [],
    recipes: recipes || [],
    global_recipes: globalRecipes || [],
    preference_swipes: swipes || [],
    meal_plans: plans || [],
    meal_feedback: feedback || [],
  };

  const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const date = new Date().toISOString().split('T')[0];

  const a = document.createElement('a');
  a.href = url;
  a.download = `suppertide-data-${date}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
